import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { APIService } from 'api/module'
import { ClickSharingModalComponent } from 'click/components/clickSharingModal.component'
import { AssetMini, CloudConnection } from 'elements-sdk'

@Injectable({ providedIn: 'root' })
export class ClickService {
  supportedAssetTypes = ['video', 'audio', 'pdf', 'office', 'image']
  $uibModal: any

  constructor (
    private api: APIService,
    private ngbModal: NgbModal,
  ) { }

  async share (connection: CloudConnection, assets: AssetMini[]): Promise<void> {
    const uniqueAssets: AssetMini[] = []
    for (const asset of assets) {
      if (!uniqueAssets.some(x => x.id === asset.id)) {
        uniqueAssets.push(asset)
      }
    }

    const m = this.ngbModal.open(ClickSharingModalComponent)
    m.componentInstance.assets = uniqueAssets
    m.componentInstance.connection = connection
    return m.result
  }
}
